import { useUi } from '@/store/ui'
import { backendAPIConfig } from '@baseConfig'

export class VueHelper {
    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @param {string} param
     * @returns {string}
     */
    static getParameter(vue, param) {
        const provisionShopCode = vue.$route.query[param] ? vue.$route.query[param] : ''
        return provisionShopCode.toString()
    }

    /**
     * no history
     * @param {import('vue').ComponentCustomProperties} vue
     * @param {string} path
     * @returns {void}
     */
    static move(vue, path) {
        VueHelper.scrollTop()
        vue.$router.replace(path)
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @param {string} path
     * @returns {void}
     */
    static transition(vue, path) {
        VueHelper.scrollTop()
        vue.$router.push(path)
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @param {*} location 元の型はvue-routerからインポートしたLocation型
     * @return {void}
     */
    static transitionByLocation(vue, location) {
        vue.$router.push(location)
    }

    /**
     *
     * @param {string} uri
     * @param {string} query
     * @returns {void}
     */
    static redirectBaristaAuth(uri, query) {
        window.location.replace(backendAPIConfig.endpoint + uri + '?' + query)
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @returns {void}
     */
    static historyBack(vue) {
        vue.$router.go(-1)
    }

    /**
     * @returns {void}
     */
    static scrollTop() {
        window.scrollTo({ top: 0, behavior: 'auto' })
    }

    /**
     * @returns {void}
     */
    static lock() {
        const UiModule = useUi()
        const elements = document.getElementsByTagName('button')
        for (let i = 0; i < elements.length; i++) {
            elements[i].disabled = true
        }
        UiModule.updateProgress(true)
    }

    /**
     * @returns {void}
     */
    static unlock() {
        const UiModule = useUi()
        const elements = document.getElementsByTagName('button')
        for (let i = 0; i < elements.length; i++) {
            elements[i].disabled = false
        }
        setTimeout(
            (UiModule) => {
                UiModule.updateProgress(false)
            },
            500,
            UiModule
        )
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @returns {void}
     */
    static moveError404(vue) {
        VueHelper.move(vue, '/404')
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @returns {void}
     */
    static transitionError404(vue) {
        VueHelper.transition(vue, '/404')
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @returns {void}
     */
    static moveError(vue) {
        VueHelper.move(vue, '/error')
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @returns {void}
     */
    static transitionErrorLINETimeout(vue) {
        VueHelper.transition(vue, '/ltimeout')
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @param {string} code
     */
    static transitionLINEError(vue, code) {
        VueHelper.transition(vue, `/lerror?code=${code}`)
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @param {string} provisionShopCode
     * @param {string} backUrlCode
     * @param {string} backUrlPrm
     * @param {string | null} fromCode
     * @returns {void}
     */
    static transitionEditProvisionalCustomer(vue, provisionShopCode, backUrlCode, backUrlPrm, fromCode = null) {
        if (fromCode) {
            VueHelper.transitionByLocation(vue, {
                path: '/provisional/edit/' + provisionShopCode,
                query: {
                    back_url_code: backUrlCode,
                    back_url_prm: backUrlPrm,
                    from_code: fromCode
                }
            })
        } else {
            VueHelper.transitionByLocation(vue, {
                path: '/provisional/edit/' + provisionShopCode,
                query: {
                    back_url_code: backUrlCode,
                    back_url_prm: backUrlPrm
                }
            })
        }
    }

    /**
     *
     * @param {import('vue').ComponentCustomProperties} vue
     * @param {string} provisionShopCode
     * @param {string} brandSite
     * @returns {void}
     */
    static transitionMemberscardFirst(vue, provisionShopCode, brandSite) {
        VueHelper.transitionByLocation(vue, {
            path: '/memberscard',
            query: {
                provision_shop_code: provisionShopCode,
                brandsite: brandSite,
                first: '1'
            }
        })
    }
}
